import React from 'react';
import InventoryStockLevel from '../components/InventoryStockField';

export const buildInventoryColumns = ({
  intl,
  editingStockId,
  setInventoryStock,
  clearStock,
  onStockCommit,
  onStopEditing,
  onStartEditing,
}) => [
  {
    title: intl.formatMessage({ id: 'partNumber' }),
    keyName: 'partNumber',
    customComponent: (row) => row.partNumberDisplay,
  },
  {
    title: intl.formatMessage({ id: 'name' }),
    keyName: 'name',
    editable: false,
    customComponent: (row) => row.nameDisplay,
  },
  { title: intl.formatMessage({ id: 'site' }), keyName: 'site' },
  {
    title: intl.formatMessage({ id: 'stockLevel' }),
    keyName: '_onHand',
    customComponent: (row) => (
      <InventoryStockLevel
        rowData={row}
        mixIns={{
          isEditing: row._id === editingStockId,
          autoSave: true,
          updateStock: setInventoryStock,
          clearStock,
          onCommit: onStockCommit,
          onStopEditing,
          onStartEditing,
        }}
      />
    ),
  },
  { title: intl.formatMessage({ id: 'lastUpdated' }), keyName: 'lastUpdated' },
];
